import { defineStore } from 'pinia'

interface ExhibitionStoreState {
    detail: Record<string, any>;
    rateValue: number;
    rateData: Record<string, number>;
    periodicalList: Record<string, any>;
    exhibitorData: Record<string, any>;
}

export const useExhibitionStore = defineStore('exhibition', {
    state: (): ExhibitionStoreState => ({
        detail: {},
        rateValue: 0,
        rateData: {},
        periodicalList: {
            price: 0
        },
        exhibitorData: {}
    }),

    actions: {
        setDetail(detail: Record<string, any>) {
            this.detail = detail
        },

        setRateValue(value: number) {
            this.rateValue = value
        },

        setRateData(data: Record<string, number>) {
            this.rateData = data
        },

        setPeriodicalList(list: Record<string, any>) {
            this.periodicalList = list
        },

        setExhibitorData(data: Record<string, any>) {
            this.exhibitorData = data
        },
    }
}) 